<template>
  <v-widget
    :title="$t('Role Users')"
    class="mb-4"
  >
    <div slot="widget-header-action">
      <v-btn
        flat
        class="text--secondary text-capitalize"
        @click="addUsersDialog=true"
      >
        {{ $t('Add Users') }}
      </v-btn>
    </div>

    <div slot="widget-content">
      <v-flex>
        <v-text-field
          v-model="search"
          :label="$t('Search')"
          append-icon="search"
          single-line
          hide-details
        />
      </v-flex>

      <v-data-table
        :items="role.users"
        :headers="headers"
        :search="search"
        :rows-per-page-text="$t('Rows per page')"
        item-key="name"
      >
        <template v-slot:items="{ item }">
          <tr>
            <td>{{ item.name }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.type }}</td>
            <td class="text-xs-right">
              <v-icon
                color="red"
                small
                @click="deleteUser(item)"
              >
                delete
              </v-icon>
            </td>
          </tr>
        </template>
        <template v-slot:pageText="props">
          <span>{{ $t('{0} - {1} of {2}', [props.pageStart, props.pageStop, props.itemsLength]) }}</span>
        </template>
      </v-data-table>

      <AddRelationDialog
        :dialog="addUsersDialog"
        :headers="usersDialogHeaders"
        :fields="usersDialogFields"
        :selected="role.users"
        :model-get-request-config="usersGetRequestConfig"
        :title="$t('Add Users')"
        model="auth:user"
        @relation-items-added="addUsers"
        @dialog-closed="addUsersDialog=false"
      />
    </div>
  </v-widget>
</template>

<script>
import AddRelationDialog from '@/vuetify-console/components/AddRelationDialog'

export default {
  name: 'RoleUsers',

  components: {
    AddRelationDialog
  },

  props: {
    role: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      menu: false,
      search: '',
      addUsersDialog: false,
      usersDialogFields: [
        { name: 'name', format: 'string' },
        { name: 'email', format: 'string' },
        { name: 'type', format: 'string' }
      ],
      usersGetRequestConfig: {
        headers: { 'x-user-type': 'admin' }
      }
    }
  },

  computed: {
    headers () {
      return [
        { text: this.$t('Name'), value: 'name' },
        { text: this.$t('Email'), value: 'email' },
        { text: this.$t('Type'), value: 'type' }
      ]
    },

    usersDialogHeaders () {
      return [
        { text: this.$t('Name'), value: 'name' },
        { text: this.$t('Email'), value: 'email' },
        { text: this.$t('Type'), value: 'type' }
      ]
    }
  },

  methods: {
    deleteUser (user) {
      this.role.users = this.role.users.filter(e => e.id !== user.id)
    },

    addUsers (users) {
      this.role.users = this.role.users ? this.role.users.concat(users) : users
      this.addUsersDialog = false
    }
  }
}
</script>
